export default __webpack_public_path__ + "static/media/installation_safari1.d6b45709.png";